import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TestService } from './../../../../../../../test/service/test.service';
import { UserDto } from '../../../../../../../shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

/**
 * Parametre olarak gelen kullanici, veritabaninda tum yetkileriyle birlikte klonlanir.
 * Klonlamadan once, Kullanici Ad Soyad, UserName ve Password degeri istenir. 
 */
@Component({
  selector: 'kt-user-clone',
  templateUrl: './user-clone.component.html',
  styleUrls: ['./user-clone.component.scss']
})
export class UserCloneComponent implements OnInit {

  modalTitle : string = '-';
  modalSaving : boolean = false ;
  modalSaveButtonTitle : string = 'Kopya Oluştur';
  user : BehaviorSubject<UserDto> = new BehaviorSubject<UserDto>(null);

  @ViewChild('modalTemplateNewUserInfo',  {static: true}) modalUserInfo: TemplateRef<any>;
  
  constructor(
    private _dialog: MatDialog,
    public _testService: TestService
  ) { }

  ngOnInit() {
      this._testService.getUser().subscribe(usr =>{
        this.user.next(usr);
        
      });

      
  }

  onUserClone(): void{
    const modalSettings = {width:'900px', panelClass: 'kt-mat-dialog-container__wrapper',  hasBackdrop: true};

    const dialogRef = this._dialog.open(this.modalUserInfo, modalSettings);

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog Ref Result', result);
      if (result == true) {
        console.log("Dialog uzerinden tamama basildi");
      }
    });
  }

  modalOnSubmit(): void{

  }

}
